import React from 'react';
import SimpleEditor from '../ESR/editor/texteditor/texteditor';
import { Help, Panel } from './ui';

/**
 * A rich-text field that does not fight the editor it wraps.
 *
 * SimpleEditor is uncontrolled: it takes `initialData` once and owns the document from
 * then on. Passing the current value back into it on every keystroke would reset the
 * document mid-edit and put the caret at the start, so `initialData` is deliberately read
 * once, and the value flows out through onChange only.
 *
 * `editorKey` is the field name rather than anything derived from the content, so loading
 * a different revision remounts the editor with that revision's text while ordinary
 * typing does not.
 *
 * It lives here rather than inside a step because the writing sits beside the numbers it
 * describes: the integrity summary on the integrity step, the price summary and the note
 * on the pricing step.
 */
const RichField: React.FC<{
  label: string;
  help: React.ReactNode;
  value: string;
  onChange: (html: string) => void;
  editorKey: string;
}> = ({ label, help, value, onChange, editorKey }) => (
  <Panel title={label}>
    <Help>{help}</Help>
    <div style={{ maxWidth: 820 }}>
      <SimpleEditor key={editorKey} initialData={value ?? ''} onChange={onChange} editable />
    </div>
  </Panel>
);

export default RichField;
